import { NetworkSetup } from "../network-setup";
import { SKRT_ABI } from "./skrt-abi";
import { USDT_ABI } from "./usdt-abi";

export const ropstenNetworkSetup: NetworkSetup = {
  chain: "ROPSTEN",
  contracts: {
    skrt: {
      address: "0xBCDdfEb91FC4e3a16b1eA1744AbF57fab5f3C872",
      abi: SKRT_ABI,
      decimals: 18,
    },
    usdt: {
      decimals: 18,
      address: "0x5fd92c253882bc9e23eef8d46c2898c533a02ddb",
      abi: USDT_ABI,
    },
  },
  purchase: () =>
    Promise.reject("purchasing is not supported for this network"),
  stake: () => Promise.reject("staking is not supported for this network"),
  unstake: () => Promise.reject("unstaking is not supported for this network"),
};
